function initHoverMenu() {
    const detailsElements = document.querySelectorAll('.header__inline-menu details');

    detailsElements.forEach((details) => {
        let closeTimeout;
        const summary = details.querySelector('summary');

        // Open on mouseenter (Desktop Only)
        details.addEventListener('mouseenter', () => {
            if (window.matchMedia('(min-width: 990px)').matches) {
                if (closeTimeout) {
                    clearTimeout(closeTimeout);
                    closeTimeout = null;
                }

                if (!details.hasAttribute('open')) {
                    details.setAttribute('open', 'true');
                    if (summary) summary.setAttribute('aria-expanded', 'true');
                }
            }
        });

        // Close on mouseleave with delay (Desktop Only)
        details.addEventListener('mouseleave', () => {
            if (window.matchMedia('(min-width: 990px)').matches) {
                closeTimeout = setTimeout(() => {
                    if (details.hasAttribute('open')) {
                        details.removeAttribute('open');
                        if (summary) summary.setAttribute('aria-expanded', 'false');
                    }
                }, 300);
            }
        });

        // Parent Link Click Navigation (Desktop Only)
        if (summary && summary.hasAttribute('data-url')) {
            summary.addEventListener('click', (e) => {
                // We only want to handle navigation if we are in desktop mode (hover enabled)
                if (window.matchMedia('(min-width: 990px)').matches) {
                    const url = summary.getAttribute('data-url');

                    // Verify URL is valid and navigatable
                    if (url && url !== '#' && url !== '' && url !== 'javascript:void(0)') {
                        e.preventDefault(); // Stop the default toggle behavior
                        window.location.href = url; // Manually navigate
                    }
                }
            });
        }
    });
}

document.addEventListener('DOMContentLoaded', initHoverMenu);
